import { Controller } from "@hotwired/stimulus";

// ブラウザバック時にページをリロードさせる
export default class extends Controller {
  connect() {
    window.addEventListener("pageshow", this.handlePageShow.bind(this));
  }

  handlePageShow(event) {
    if (event.persisted) {
      window.location.reload();
    }
  }
}
